<script>
module.exports = {
    data() {
        return {
            mapDrawMode: null,
            mapFeatures: [],
            mapShape: [],
            mapCenter: [],
            mapArea: 0,
            first: 1,
        }
    },
    
    methods: {
        enableDraw(mode) 
        {
            this.dispatchEvent('tecnomap.drawer.changeMode', { mode: mode })
        },

        toggleFeatureFilter(event)
        {
            if(this.checkMapScope(event) && this.mapPopupAttached == false)
            {
                console.log('toggleFeatureFilter', event)

                let feature = event.detail.feature

                if(feature.user_country == 'hu' && feature.user_type == 'city')
                {
                    this.dispatchEvent('tecnomap.drawer.fitScreenPolygon', {
                        feature: feature.id
                    })

                    window.events.$emit('search_by_districts', {
                        // id: null,
                        city_id: feature.user_id,
                    });

                    // window.events.$emit('search_by_city', {
                    //     id: feature.user_id,
                    // });
                }
                else if(feature.user_type == 'district')
                {
                    let districts = this.searchCriteria()['districts']

                    if(_.isEmpty(districts) || (districts.length == 1 && districts[0] == ''))
                    {
                        districts = this.polygonsIdentifiers.districts
                    }

                    if(feature.user_enabled || feature.user_enabled == undefined)
                    {
                        districts = districts.filter(item => String(item) !== String(feature.user_id))
                    }
                    else
                    {
                        if(feature.user_enabled)
                        {
                            districts = districts.filter(item => String(item) !== String(feature.user_id))
                        }
                        else
                        {
                            districts.push(feature.user_id)
                        }
                    }

                    this.dispatchEvent('tecnomap.drawer.setPolygonProperty', {
                        feature: feature.id,
                        properties: {
                            enabled: !feature.user_enabled
                        }
                    })

                    window.events.$emit('search_by_districts', {
                        id: districts.join('|'),
                        city_id: this.searchCriteria()['city'],
                    })
                }
            }
        },

        updateCurrentDrawMode(event)
        {
            if(this.checkMapScope(event))
            {
                this.mapDrawMode = null
                Object.keys(event.detail.modes).forEach(element => {
                    if(event.detail.modes[element] == true)
                        this.mapDrawMode = element
                })
            }
        },

        updateShapes(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('updateShapes', event)
                let placeholderChange = (this.mapArea || this.first) ? 0 : 1
                this.first = 0
                this.mapFeatures = event.detail.features
                this.mapShape = event.detail.shape
                this.mapCenter = event.detail.center
                this.mapArea = event.detail.area

                let featuresUser = this.mapFeatures.filter(function (feature) {
                    return feature.properties.type == undefined
                })

                if(featuresUser.length > 0)
                {
                    console.log(featuresUser)
                    axios.post('/api/estates/save-polygons', {
                        features: featuresUser,
                        shape: featuresUser,
                        center: this.mapCenter,
                        area: this.mapArea,
                    })
                    .then((response) => {
                        this.mapSearch['polygon_id'] = response.data.polygon_id
                        window.events.$emit('list.update.polygon_id', this.mapSearch['polygon_id'])
                        window.events.$emit('update-save-search-disable', false)
                        window.events.$emit('bottommenu.map.polygons.features', featuresUser)
                        window.events.$emit('list.update.filters.polygon_id', this.mapSearch['polygon_id'])
                        // if (placeholderChange) {
                        //     window.events.$emit('update-search-placeholder', this.lang.placeholders.map)
                        // }
                        this.requestEstates()
                    })
                    .catch((error) => {
                        //
                    })
                }
                else if(this.mapSearch['polygon_id'] != null)
                {
                    this.mapSearch['polygon_id'] = null
                    window.events.$emit('list.update.polygon_id', null)
                    window.events.$emit('list.update.filters.polygon_id', null)
                    window.events.$emit('bottommenu.map.polygons.features', null)

                    this.requestEstates()
                }
            }
        },
        
        emptyShape(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('emptyShape', event)
                this.mapFeatures = []
                this.mapShape = []
                this.mapCenter = []
                this.mapArea = 0

                this.mapSearch['polygon_id'] = null
                window.events.$emit('list.update.polygon_id', null)

                this.dispatchEvent('tecnomap.drawer.setMarkers', { featureCollection: {
                    type: 'FeatureCollection',
                    features: []
                }}, 'mapDrawerLoaded')

                // window.events.$emit('list.heading.count', 0)

                this.mapSearch['view'] = [
                    event.detail.bbox._ne.lat, event.detail.bbox._ne.lng,
                    event.detail.bbox._sw.lat, event.detail.bbox._sw.lng
                ].join(',')
                window.events.$emit('list.update.bounds', this.mapSearch['view'])
                // window.events.$emit('update-search-placeholder', this.lang.placeholders.visible)
                window.events.$emit('has-districts-disable')
                window.events.$emit('update-save-search-disable', true)

                this.requestEstates()
            }
        },
    },

    mounted() {
        window.addEventListener('tecnomap.click.feature', this.toggleFeatureFilter)
        window.addEventListener('tecnomap.drawer.powerModes.status', this.updateCurrentDrawMode)
        window.addEventListener('tecnomap.drawer.shapeUpdated', this.updateShapes)
        window.addEventListener('tecnomap.drawer.empty', this.emptyShape)
    },

    beforeDestroy() {
        window.removeEventListener('tecnomap.click.feature', this.toggleFeatureFilter)
        window.removeEventListener('tecnomap.drawer.powerModes.status', this.updateCurrentDrawMode)
        window.removeEventListener('tecnomap.drawer.shapeUpdated', this.updateShapes)
        window.removeEventListener('tecnomap.drawer.empty', this.emptyShape)
    }
}
</script>